import { atom, selector } from 'recoil';
import { recoilPersist } from 'recoil-persist'
const localStorage = typeof window !== `undefined` ? window.localStorage : null
const { persistAtom } = recoilPersist({
  key: 'recoil-persist-v2', // bump this key on breaking state shape changes
  storage: localStorage,
})

const authAtom = atom({
  key: 'auth',
  // get initial state from local storage to enable user to stay logged in
  default: null,
  effects_UNSTABLE: [persistAtom],
});

const userToken = selector({
  key: 'userToken',
  get: ({ get }) => {
    const details = get(authAtom);
    return details?.token
  },
});


export { authAtom, userToken };
